import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-lightbox-image-dialog',
  template: `
    <div class="lightbox-backdrop" (click)="dialogRef.close()">
      <img [src]="image" alt="Full Image" class="lightbox-image" />
    </div>
  `,
  styles: [`
    .lightbox-backdrop {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.85);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    }
    .lightbox-image {
      max-width: 90%;
      max-height: 90%;
      border-radius: 8px;
      box-shadow: 0 0 12px rgba(0,0,0,0.5);
    }
  `]
})
export class LightboxImageDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<LightboxImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public image: string
  ) {}
}
